// import { useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";

// const RoleBasedProtectedRoute = ({ children }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     const storedUser = JSON.parse(sessionStorage.getItem("user"));
//     const storedToken = sessionStorage.getItem("token");

//     if (!storedUser || !storedToken) {
//       sessionStorage.setItem("redirectPath", location.pathname);
//       navigate("/login");
//     } else {
//       const userRole = storedUser?.user?.role || storedUser?.role;

//       if (
//         userRole === "student" &&
//         location.pathname !== "/" &&
//         !location.pathname.startsWith("/student")
//       ) {
//         navigate("/");
//       } else if (
//         userRole === "teacher" &&
//         !location.pathname.startsWith("/dashboard") &&
//         location.pathname !== "/dashboard"
//       ) {
//         navigate("/dashboard");
//       } else if (
//         userRole === "admin" &&
//         location.pathname !== "/admin-dashboard" &&
//         !location.pathname.startsWith("/admin-dashboard")
//       ) {
//         navigate("/admin-dashboard");
//       }
//     }
//   }, [location.pathname, navigate]);
//   return children;
// };

// export default RoleBasedProtectedRoute;

// import { useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";

// const RoleBasedProtectedRoute = ({ children }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     if (location.pathname === "/") {
//       return; // Allow access to "/" for everyone
//     }

//     const storedUser = JSON.parse(sessionStorage.getItem("user"));
//     const storedToken = sessionStorage.getItem("token");

//     if (!storedUser || !storedToken) {
//       sessionStorage.setItem("redirectPath", location.pathname);
//       navigate("/login");
//     } else {
//       const userRole = storedUser?.user?.role || storedUser?.role;

//       if (userRole === "student" && !location.pathname.startsWith("/student")) {
//         navigate("/");
//       } else if (
//         userRole === "teacher" &&
//         !location.pathname.startsWith("/dashboard")
//       ) {
//         navigate("/dashboard");
//       } else if (
//         userRole === "admin" &&
//         !location.pathname.startsWith("/admin-dashboard")
//       ) {
//         navigate("/admin-dashboard");
//       }
//     }
//   }, [location.pathname, navigate]);

//   return children;
// };

// export default RoleBasedProtectedRoute;

// import { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import LoginModal from "../../src/Pages/LoginModelPage";

// const RoleBasedProtectedRoute = ({ children }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [showLoginModal, setShowLoginModal] = useState(false);

//   useEffect(() => {
//     if (location.pathname === "/") return; // Allow public access to "/"

//     const storedUser = JSON.parse(sessionStorage.getItem("user"));
//     const storedToken = sessionStorage.getItem("token");

//     if (!storedUser || !storedToken) {
//       sessionStorage.setItem("redirectPath", location.pathname);
//       setShowLoginModal(true);
//       return;
//     }

//     const userRole = storedUser?.role;

//     if (userRole === "teacher" && !location.pathname.startsWith("/dashboard")) {
//       navigate("/dashboard");
//     } else if (
//       userRole === "admin" &&
//       !location.pathname.startsWith("/admin-dashboard")
//     ) {
//       navigate("/admin-dashboard");
//     }
//   }, [location.pathname, navigate]);

//   const handleCloseModal = () => {
//     setShowLoginModal(false);
//     navigate("/"); // ✅ Navigate to home when modal closes
//   };

//   if (showLoginModal) {
//     return <LoginModal onClose={handleCloseModal} />;
//   }

//   return children;
// };

// export default RoleBasedProtectedRoute;

import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import LoginModal from "../../src/Pages/LoginModelPage";
import Loader from "../comman/Loader";

const RoleBasedProtectedRoute = ({ children, allowedRoles = [] }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(null); // ⏳ Start in loading state

  useEffect(() => {
    const storedUser = JSON.parse(sessionStorage.getItem("user"));
    const storedToken = sessionStorage.getItem("token");

    if (!storedUser || !storedToken) {
      sessionStorage.setItem("redirectPath", location.pathname);
      setShowLoginModal(true);
      return;
    }

    const userRole = storedUser?.role;

    // ✅ Check if the user's role is allowed
    if (allowedRoles.length > 0 && !allowedRoles?.includes(userRole)) {
      navigate("/", { replace: true });
      return;
    }

    setIsAuthorized(true); // ✅ Allow rendering the protected route
  }, [location.pathname, navigate]);

  const handleCloseModal = () => {
    setShowLoginModal(false);
    navigate("/"); // ✅ Navigate home when modal closes
  };

  // ⏳ **Show a loading state to prevent flickering**
  if (isAuthorized === null && !showLoginModal) {
    return (
      <div>
        <Loader />
      </div>
    ); // 👈 Replace with your actual Loader component
  }

  // 🛑 **Show login modal if user is not authenticated**
  if (showLoginModal) {
    return <LoginModal onClose={handleCloseModal} />;
  }

  return children;
};

export default RoleBasedProtectedRoute;
